// People-type post types: support the deep-dive modal. Keep in sync with the
// WP `sourcePostType` ACF choices.
export const DEEP_DIVE_POST_TYPES = ['staff', 'board-members'];

// Per-post-type sort. Board members follow the manual WP admin order
// (`menu_order`, ascending); staff are alphabetical; anything unlisted falls
// back to newest-first by date.
const ORDER_BY = { staff: 'title', 'board-members': 'menu_order' };
export const resolveOrderby = (postType) => ORDER_BY[postType] ?? 'date';

export function transformCardGrid(data) {
  const sourcePostType = Array.isArray(data?.sourcePostType)
    ? data.sourcePostType[0]
    : data?.sourcePostType || 'page';

  return {
    type: 'card-grid',

    heading: data?.heading || false,
    sourcePostType: sourcePostType,
    orderby: resolveOrderby(sourcePostType),
  };
}
